{
  "#PORTAL_REGISTRATION": {
    "TITLE": "Registrierung",
    "EMAIL": "E-Mail",
    "PASSWORD": "Passwort",
    "PASSWORD_CONFIRM": "Passwort wiederhohlung",
    "FIRST_NAME": "Vorname",
    "LAST_NAME": "Nachname",
    "COMPANY": "Firma",
    "SUBMIT": "Registrieren",
    "LOGIN": "Login",
    "VALIDATION": {
      "PASSWORD": {
        "MIN_LENGTH": "Muss mindestens {{requiredLength}} Zeichen lang sein",
        "MIN_LENGTH_MESSAGE": "Aktuell: {{actualLength}}",
        "UPPERCASE": "Muss mindestens einen Großbuchstaben enthalten",
        "LOWERCASE": "Muss mindestens einen Kleinbuchstaben enthalten",
        "NUMBER": "Muss mindestens eine Zahl enthalten",
        "SYMBOL": "Muss mindestens ein Sonderzeichen enthalten",
        "OPTIONAL": "(optional)"
      },
      "PASSWORD_REPEAT": {
        "UNEQUAL": "Die Passwörter stimmen nicht überein!"
      }
    },
    "MESSAGES": {
      "SUCCESS": {
        "TITLE": "Sie wurden erfolgreich registriert",
        "MESSAGE": "Bitte folgen sie den Anweisungen in der Bestätigungs Mail um Ihre E-Mail Adresse zu bestätigen."
      },
      "FAILURE": "Sie konnten nicht registriert werden"
    },
    "CONFIRM": {
      "TITLE": "Bestätigung",
      "USERNAME": "Benutzername",
      "MESSAGES": {
        "SUCCESS": {
          "TITLE": "Ihre E-Mail Adresse wurde bestätigt",
          "MESSAGE": "Sie erhalten eine Benachrichtigung sobald Ihr Konto von einem Administrator geprüft und freigeschalten wurde"
        },
        "FAILURE": "Ihre E-Mail Adresse konne nicht bestätigt werden"
      }
    }
  },
  "#PORTAL_REGISTRATION_ADMIN": {
    "TITLE": "Kundenverwaltung",
    "CAPTION": "Folgender Kunde möchte gerne ein Kundenkonto haben",
    "EMAIL": "E-Mail",
    "NAME": "Name",
    "CUSTOMER_DESCRIPTION": "Kundenbezeichnung",
    "EMAIL_CONFIRMED": "Hat seine Email-Adresse bestätigt",
    "IS_ACTIVE": "Wurde freigeschaltet",
    "ASSIGNED_CUSTOMERS": "Zugeordnete Kunden",
    "CUSTOMER": "Kunde",
    "CONTACT": "Kontakt",
    "ADD_CUSTOMER": "Weiteren Kunden hinzufügen",
    "REMOVE_CUSTOMER": "Kunde Löschen",
    "PERMISSIONS": "Anwender darf alle Tickets des/der Kunden sehen (Berechtigung TICKET.KTOSTAMM)",
    "CUSTOMER_INPUT": {
      "NUMBER": "Nummer",
      "NAME": "Name",
      "QUERY": "Abfrage",
      "DATA": "Daten",
      "NO_DATA": "Es konnten keine Daten gefunden werden"
    },
    "STATE": {
      "YES": "Ja",
      "NO": "Nein"
    },
    "CONTACT_INPUT": {
      "CREATE_CONTACT": "Neuen Kontakt anlegen"
    },
    "SUBMIT": "Speichern",
    "MESSAGES": {
      "SUCCESS": "Der Anwender wurde erfolgreich freigeschalten",
      "FAILURE": "Der Anwender konnte nicht freigeschalten werden"
    }
  }
}
